/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskAtlassianAnalyticsResource } from '@jira/router-resources__reports-atlassian-analytics/src/servicedeskAtlassianAnalyticsResource.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskAtlassianAnalyticsRoute } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskAtlassianAnalyticsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { AtlassianAnalytics, LazyAtlassianAnalytics } from './ui/atlassian-analytics/index.tsx';

export const servicedeskAtlassianAnalyticsRouteEntry: Route = createEntry(
	servicedeskAtlassianAnalyticsRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: AtlassianAnalytics,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			servicedeskAtlassianAnalyticsResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyAtlassianAnalytics],

		meta: {
			reporting: {
				id: APP_NAMES.ATLASSIAN_ANALYTICS,
				packageName: toPackageName(APP_NAMES.ATLASSIAN_ANALYTICS),
				teamName: 'ITSM Saga',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
